import {fetchFromApiRoute} from '#/utils/fetch-utils';
import {ApiHomeSections, apiHomeSections} from '@shareland/shareland-common';

const get = async (): Promise<ApiHomeSections['get']['resBody']['data']> => {
  const res = await fetchFromApiRoute<ApiHomeSections['get']>(apiHomeSections.endpoints.get, {
    paramsDictionary: null,
    reqBody: null,
    reqQuery: {},
  });

  return res ?? null;
};

export const apiHomeSectionsRequests = {
  get,
};
